import React from 'react';
import {ScrollView, Text} from 'react-native';
import {storiesOf} from '@storybook/react-native';

import {
  Code,
  FlexView,
  Heading,
  Spacer,
  Spacing,
} from '/component/base/Storybook';

import ReportIconButton from '../ReportIconButton';

storiesOf('partial', module).add('ReportIconButton', () => (
  <ScrollView>
    <Spacing size={20}>
      <FlexView>
        <Heading level={1}>Report Icon Button</Heading>
        <Spacer size={16} />
        <Text>
          The <Code>ReportIconButton</Code> component is used to render a button
          with icon in report screens.
        </Text>
        <Spacer size={16} />
        <Text>
          To name of the icon being displayed can be specified via the{' '}
          <Code>iconName</Code> prop.
        </Text>
        <Spacer size={16} />
        <ReportIconButton iconName="filter" sortLabel={'Filter Yo!'} />
        <Spacer size={6} />
        <Code>
          {'<ReportIconButton iconName="filter" sortLabel="Filter Yo!">'}
        </Code>
        <Spacer size={16} />
        <ReportIconButton iconName="sort" sortLabel={'Sort by Something'} />
        <Spacer size={6} />
        <Code>
          {
            '<ReportIconButton iconName="sort"> sortLabel="Sort by Something" />'
          }
        </Code>
      </FlexView>
    </Spacing>
  </ScrollView>
));
